<template>
  <div class="user-register">
    <div class="user-register-content">
      <!-- 注册窗 -->
      <section class="login-content left">
        <h3>
          {{ $t('text.createNewAccount') }}
        </h3>
        <div>
          <v-form ref="register" :model="register" :rules="registerRuleValidate" :label-width="148" label-position="right">
            <!-- 手机 -->
            <v-form-item :label="$t('user.phone.mobile')" prop="account">
              <v-input class="iview-input" v-model="register.account" size="large" :placeholder="$t('tip.input.phone')"></v-input>
            </v-form-item>
            <!-- 图形验证码 -->
            <v-form-item prop="imageCode">
              <v-input class="iview-input-code" size="large" v-model="register.imageCode" :placeholder="$t('tip.input.code[0]')"></v-input>
              <img class="code-img" :src="imageCode" alt="验证码" @click.stop="getImageCode">
            </v-form-item>
            <!-- 手机验证码 -->
            <v-form-item :label="$i18n.locale === 'zh' ? $t('system.code') : $t('CAPTCHA')" prop="phoneCode">
              <v-input class="iview-input-forget" size="large" v-model="register.phoneCode" :placeholder="$t('tip.input.code[1]')"></v-input>
              <Button class="iview-input-forget-button cd-btn" @click="verifyImageCode" :disabled="createTime > 0">
                {{ $t('system.getCode') }}
                <template v-if="createTime">
                  ( {{ ((createTime - new Date().getTime()) / 1000).toFixed(0) }} )
                </template>
              </Button>
            </v-form-item>
            <!-- 城市 -->
            <v-form-item :label="$t('text.city')" prop="cityId">
              <v-city-select ref="city" :city="cityData" @select="handleSelectCity">
                <span slot="tip" class="global-city-select-tip">
                  <!-- {{ selectCity.city ? selectCity.city.cityName : $t('text.select[0]') }} -->
                  {{ selectCity.city ? selectCity.city.cityName : $t('text.select[0]') }}
                </span>
                <div slot="title" class="global-city-select-title">
                  <span v-if="selectCity.province === null">{{ $t('center.addrmanage.select.province[0]') }}</span>
                  <span v-else>{{ $t('center.addrmanage.select.province[2]') }}</span>
                  <span class="back" @click="selectCity.province = null" v-if="selectCity.province !== null">
                    &nbsp;{{$t('center.addrmanage.select.province[1]')}}
                  </span>
                </div>
              </v-city-select>
            </v-form-item>
            <!-- 密码 -->
            <v-form-item :label="$t('user.password')" prop="password">
              <v-input class="iview-input" type="password" size="large" v-model="register.password" :placeholder="$t('tip.input.passwordLength')"></v-input>
            </v-form-item>
            <!-- 邮箱 -->
            <v-form-item :label="$t('user.email')" prop="email">
              <v-input class="iview-input" v-model="register.email" size="large" :placeholder="$t('tip.input.email')"></v-input>
            </v-form-item>
            <v-form-item class="item-not-margin">
              <v-checkbox class="iview-checkbox" v-model="deal.watch">
                {{ `&nbsp;&nbsp;${$t('text.hope')}` }}
              </v-checkbox>
            </v-form-item>
            <v-form-item class="item-not-margin">
              <v-checkbox class="iview-checkbox" v-model="deal.yes">
                {{ `&nbsp;&nbsp;${$t('text.read.end')}` }}
                <router-link to="/info-footer/privacy">
                  {{ `&nbsp;&nbsp;${$t('statement.privacy')}` }}
                </router-link>
              </v-checkbox>
            </v-form-item>
          </v-form>
        </div>
        <Button class="cd-btn register-btn register" size="large" @click="goRegister" :loading="showRegisterLoading">
          {{$i18n.locale === 'zh' ? $t('system.register') : $t('button.submit') }}
        </Button>
      </section>
      <!-- 登录窗 -->
      <section class="login-content right">
        <h3>
          {{ $t('text.haveAccount') }}
        </h3>
        <v-form class="login-section" ref="login" :model="login" :rules="ruleValidate" :label-width="60" label-position="left">
          <!-- 账号 -->
          <v-form-item :label-width="$i18n.locale === 'en' ? 90 : 70" class="iview-label" :label="$t('user.account')" prop="account">
            <v-input class="iview-input" v-model="login.account" size="large" :placeholder="$t('tip.input.smsEmail')"></v-input>
          </v-form-item>
          <!-- 密码 -->
          <v-form-item class="iview-label" :label-width="$i18n.locale === 'en' ? 90 : 70" :label="$t('user.password')" prop="password">
            <v-input class="iview-input" type="password" size="large" v-model="login.password" :placeholder="$t('tip.input.password')"></v-input>
          </v-form-item>
        </v-form>
        <p>
          <v-checkbox v-model="isCatch">
            {{ `&nbsp;&nbsp;${$t('system.remember')}` }}
          </v-checkbox>
          <span>
            <a href="javascript:void(0);" @click="toForgetPw">
              {{ $t('system.forgetPw') }}
            </a>
          </span>
        </p>
        <p class="tip"></p>
        <Button class="cd-btn register-btn login" size="large" @click="goLogin" :loading="showLoginLoading">
          {{ $t('system.signin') }}
        </Button>
      </section>
    </div>
    <section class="tip">
      <h4>{{ $t('text.registertips.reminder[0]') }}</h4>
      <i18n path="text.registertips.reminder[1]" tag="p" for="text.registertips.phone">
        <strong>{{ $t('text.registertips.phone') }}</strong>
      </i18n>
      <!-- <p>若您在注册会员或者在线订餐时遇到问题，请致电 400-810-7272，由客服人员为您提供帮助。</p> -->
      <h4>{{ $t('text.registertips.servicetime[0]') }}</h4>
      <i18n path="text.registertips.servicetime[1]" tag="p">
        <span slot="start">{{ $t('text.registertips.time[0]') }}</span>
        <span slot="end">{{ $t('text.registertips.time[1]') }}</span>
      </i18n>
      <!-- <p>周一至周日，09:30 至 22:00， 节假日照常。</p> -->
    </section>
    <v-modal
      v-model="showModal"
      width="500"
      :styles="{top: '183px'}"
      :closable="false"
      :mask-closable="false">
      <p slot="header" class="register-header">
        <!-- 注册成功提标题 -->
        {{ $t('tip.success.register') }}
      </p>
      <p class="register-content">{{ $t('tip.success.register') }}</p>
      <div slot="footer" class="register-footer">
        <!-- 跳过 -->
        <Button class="cd-btn cd-btn-skip" size="large" @click.stop="skip">
          {{ $t('button.skip') }}
        </Button>
        <!-- 完善信息 -->
        <Button class="cd-btn cd-btn-button" size="large" @click="fill">
          {{ $t('button.user.info') }}
        </Button>
      </div>
    </v-modal>
  </div>
</template>

<script>
import {
  Form, FormItem, Input, Checkbox, Modal,
} from 'iview';
import md5 from 'blueimp-md5';
import VCitySelect from '@/components/city.vue';

export default {
  name: 'register',
  components: {
    VModal: Modal,
    VForm: Form,
    VFormItem: FormItem,
    VInput: Input,
    VCheckbox: Checkbox,
    VCitySelect,
  },
  data() {
    const phoneAndMailValidate = {
      validator: (rule, value, callback) => {
        const isPhone = /^\d+$/.test(value) && (value.length === 8 || value.length === 11);
        const isMail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value);
        if (isMail || isPhone) {
          callback();
          return;
        }
        callback(new Error(this.$t('tip.input.phoneNum')));
      },
      trigger: 'blur',
    };
    const phoneValidate = {
      validator: (rule, value, callback) => {
        const isPhone = Boolean(/^\d+$/.test(value) && (value.length === 8 || value.length === 11));
        if (isPhone) {
          callback();
          return;
        }
        callback(new Error(this.$t('tip.input.phoneNum')));
      },
      trigger: 'blur',
    };
    return {
      isCatch: false, // 控制是否缓存账号密码
      showModal: false, // 控制显示弹框
      showLoginLoading: false, // 控制是否显示按钮loading事件
      showRegisterLoading: false, // 控制是否显示按钮loading事件
      city: [],
      selectCity: {
        province: null,
        city: null,
      }, // 已选择的省市
      imageCode: '',
      deal: { // 注册账号可勾选的协议
        watch: true,
        yes: true,
      },
      createTime: '', // 保存本次获取验证码的时间
      timer: '', // 倒计时setTimeout的id
      login: { // 登录信息对象
        account: '',
        password: '',
      },
      register: { // 注册信息对象
        account: '',
        imageCode: '',
        phoneCode: '',
        password: '',
        email: '',
        cityId: '',
      },
      registerRuleValidate: { // 注册框表单验证规则
        account: [{
          required: true,
          message: this.$t('tip.input.phoneNum'), // 必填
          trigger: 'blur',
        }, phoneValidate],
        imageCode: [{ // 图片验证码
          required: true,
          message: this.$t('tip.input.code[0]'), // 必填
          trigger: 'blur',
        }],
        phoneCode: [{ // 手机验证码
          required: true,
          message: this.$t('tip.input.code[0]'), // 必填
          trigger: 'blur',
        }],
        password: [{ // 新密码
          required: true,
          message: this.$t('tip.input.password'), // 必填
          trigger: 'blur',
        }, {
          type: 'string',
          min: 6,
          max: 16,
          message: this.$t('tip.psdLenghtAlert'), // 长度限制
          trigger: 'blur',
        }],
        email: [{
          type: 'string',
          required: true,
          message: this.$t('tip.input.email'), // 必填
        }, {
          // 判断是否是邮箱
          validator: (rule, value, callback) => {
            if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
              callback();
              return;
            }
            callback(new Error(this.$t('tip.error.email')));
          },
          trigger: 'blur',
        }],
        cityId: [{
          required: true,
          // message: this.$t('text.select[0]') + ' ' + this.$t('text.city'), // 必填
          message: `${this.$t('text.select[0]')} ${this.$t('text.city')}`, // 必填
        }],
      },
      ruleValidate: { // 登录框表单验证规则
        account: [{
          required: true,
          message: this.$t('tip.input.account'),
          trigger: 'blur',
        }, phoneAndMailValidate],
        password: [{
          required: true,
          message: this.$t('tip.input.password'),
          trigger: 'blur',
        }, {
          type: 'string',
          min: 6,
          max: 16,
          message: this.$t('tip.psdLenghtAlert'),
          trigger: 'blur',
        }],
      },
      citySearch: null,
    };
  },
  computed: {
    cityData() {
      // 已选择的城市，如果没选择则为省份
      if (this.selectCity.province !== null) {
        return this.city[this.selectCity.province].citys;
      }
      return this.city;
    },
  },
  created() {
    // 初始化验证码
    this.getImageCode();
    // 获取城市列表
    this.cityList()
      .then(() => {
        this.positioning();
      });
  },
  methods: {
    toForgetPw() {
      // 打开忘记密码框
      try {
        if (this.$root.$children[0]) {
          this.$root.$children[0].openLoginModal('/', 'forget');
        }
      } catch (err) {
        this.$router.push('/');
      }
    },
    positioning() {
      // this.getAMap();
      if (!this.citySearch && window.AMap.CitySearch) {
        this.citySearch = new window.AMap.CitySearch();
      } else if (!window.AMap.CitySearch) {
        console.log('else');
        return;
      }
      // 查询当前所在城市
      this.citySearch.getLocalCity((status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          // 查询成功，result即为当前所在城市信息
          const index = this.city.findIndex(city => city.provinceName === result.province);
          if (index >= 0) {
            this.selectCity.province = index;
            this.selectCity.city = this.city[index].citys.find(city => city.cityName === result.city);
            if (!this.selectCity.city) {
              // 如果地址不在列表
              this.selectCity.province = null;
              this.selectCity.city = null;
              return;
            }
            this.register.cityId = this.selectCity.city;
            // this.handleSelectCity(this.city[index].citys, index);
            // this.city = [this.selectCity.city.provinceId, this.selectCity.city.cityId];
            // 手动触发区域选中事件
            // this.handleSelectDistrict(this.city);
          }
        }
      });
    },
    // 选中城市
    // item 选中对象的值
    // index 选中对象的数组下标
    handleSelectCity({ item, index }) {
      if (item.citys) {
        this.selectCity.province = index;
        return;
      }
      this.selectCity.city = item;
      this.register.cityId = item.cityId;
      this.$refs.city.close();
    },
    // 获取城市列表
    cityList() {
      return this.$service.project.cityListAll()
        .then((data) => {
          const city = {};
          data.data.forEach((item) => {
            if (!city[item.provinceId]) {
              city[item.provinceId] = {
                provinceName: item.provinceName,
                provinceId: item.provinceId,
                citys: [],
              };
            }
            city[item.provinceId].citys.push({
              provinceName: item.provinceName,
              provinceId: item.provinceId,
              cityId: item.cityId,
              cityName: item.name,
              cityNameEn: item.nameEn,
            });
          });
          this.city = Object.values(city);
        })
        .catch((err) => {
          this.city = [];
          // this.$Message.error(获取城市列表失败');
          this.$Message.error(err);
        });
    },
    // 注册成功弹框 完善信息按钮事件
    fill() {
      this.closeModal();
      // 暂时这样写
      this.$router.push('/user-center/profile');
    },
    // 注册成功弹框 跳过按钮时间
    skip() {
      this.closeModal();
      // 选择跳过则，跳转到首页
      this.$router.push('/');
    },
    // 关闭注册成功弹框
    closeModal() {
      this.showModal = false;
    },
    // 注册用户
    goRegister() {
      if (!this.deal.yes) {
        // this.$Message.error(this.$t('tip.register.agreement'));
        this.$Modal.info({
          content: this.$t('tip.register.agreement'),
        });
        return;
      }
      this.$refs.register.validate((valid) => {
        if (!valid) {
          // 表单验证不通过
          return;
        }
        this.singUp();
      });
    },
    goLogin() {
      this.showLoginLoading = true;
      this.$refs.login.validate((valid) => {
        if (!valid) {
          // 表单验证不通过
          this.showLoginLoading = false;
          return;
        }
        this.singIn();
      });
    },
    // 用户注册
    singUp() {
      if (!this.showRegisterLoading) {
        this.showRegisterLoading = true;
      }
      // let actionName;
      const content = {};
      // if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.register.account)) {
      //   // 是否输入了邮箱
      //   actionName = 'candao.user.sendEmailVerficCode';
      //   content.email = this.register.account;
      // } else if (/^\d{8,11}$/.test(this.register.account)) {
      //   // 是否输入了手机号
      // }
      content.phone = this.register.account;
      ({
        password: content.password,
        phoneCode: content.verificCode,
        email: content.emailBind,
      } = this.register);
      content.cityId = this.register.cityId.cityId;
      this.$service.user.register({ content })
        .then((res) => {
          // 注册成功
          // 弹出是否完善信息框
          this.showModal = true;
          // 缓存用户名
          // this.$service.user.getUser()
          //   .login(res.serverTime || new Date(res.time).getTime(), res.data);
          return res;
        })
        .then(() => this.$service.user.getUserInfo())
        .then(() => {
          if (this.$root.$children[0].$refs.header) {
            // 判断父组件的main-header组件是否存在
            // 存在则更新值
            this.$root.$children[0].$refs.header.login();
            // this.$root.$children[0].$refs.header.isLogin = this.$service.user.getUser().check();
            // this.$root.$children[0].$refs.header.userName = this.$service.user.getUser().info.userName;
          }
        })
        .catch((err) => {
          // 注册失败
          this.$Message.error(err.msg || '注册失败');
        })
        .finally(() => { this.showRegisterLoading = false; });
    },
    // 用户登录
    singIn() {
      if (!this.showLoginLoading) {
        this.showLoginLoading = true;
      }
      const content = {
        loginKey: this.login.account,
        password: md5(this.login.password), // md5加密
      };
      this.$service.user.login.account({ content })
        .then(() => this.$service.user.getUserInfo())
        .then(() => {
          // 登录成功
          // this.$service.user.getUser().login(res.serverTime, res.data);
          if (this.$root.$children[0].$refs.header) {
            // 判断父组件的main-header组件是否存在
            // 存在则更新值
            this.$parent.$refs.header.login();
            // this.$root.$children[0].$refs.header.isLogin = this.$service.user.getUser().check();
            // this.$root.$children[0].$refs.header.userName = this.$service.user.getUser().info.userName;
          }
          // 跳转到首页
          this.skip();
        })
        .catch((err) => {
          // 登录失败
          console.log(err);
          this.$Message.error(err.msg || '');
          this.$service.user.getUser().clear();
        })
        .finally(() => {
          this.showLoginLoading = false;
        });
    },
    // 获取验证码图片
    getImageCode() {
      this.imageCode = `./ImageCodeAction?type=1&_${Date.parse(new Date())}`;
    },
    // 验证图片验证码
    verifyImageCode() {
      // 基本验证 图片验证码有没有输入
      if (!this.register.imageCode) {
        return;
      }
      this.$refs.register.validateField('account', (validate) => {
        console.log(validate);
        if (validate) {
          return;
        }
        let actionName;
        const content = {};
        if (/^\d{8,11}$/.test(this.register.account)) {
          // 是否输入了手机号
          actionName = 'candao.user.phoneRegistSendVerficCode';
        } else {
          // 如果不能命中以上规则，则return
          return;
        }
        content.phone = this.register.account;
        // 发送手机/邮箱验证码
        this.$service.verify.imageCodeVerify({
          actionName,
          content,
          params: { type: 1 },
          imgCode: this.register.imageCode,
        })
          .then(() => {
            // 倒计时开始
            this.createTime = new Date().getTime() + 60000; // 60秒的间隔
            this.timer = setInterval(() => {
              this.createTime -= 1000; // 每次减一秒
              if (this.createTime - new Date().getTime() <= 0) { // 倒数完重置值
                this.createTime = '';
                clearInterval(this.timer);
              }
            }, 1000);
          })
          .catch((err) => {
            console.log(err);
            // 提示用户
            this.$Message.error(err.msg || this.$t('tip.error.code'));
            // 重新获取验证码
            this.getImageCode();
          });
      });
    },
  },
};

</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'

@mixin button
  min-width: 118px
  padding: 6px 0
.item-not-margin
  margin-bottom: 0
.cd-btn-button
  @include button
.cd-btn-skip
  @include button
  background-color: #9e9899
.register-footer
  text-align: center
  padding-bottom: 30px
  button
    &:not(:first-child)
      margin-left: 42px
.register-content
  text-align: center
  color: #333
  font-size: 14px
  line-height: 32px
  margin-top: 14px
  margin-bottom: 40px
.register-header
  text-align: center
  font-size: 20px
  color: #0f9675
  font-weight: 700
.user-register
  background-color: #f5f5f5
  overflow: hidden
  @include base-wrap
  margin-top: 20px
  a
    color: #0f9675
  .tip
    margin: 50px 0 50px 32px
    font-size: 14px
    h4
      color: #0f9675
      margin-top: 10px
      font-weight: initial
    p
      color: #7a7a7a
      span
        color: #0f9675
      strong
        color: #0f9675
  .user-register-content
    display: flex
    justify-content: space-between
    .login-content
      overflow: hidden
      h3
        margin: 30px 0 32px 33px
        font-size: 22px
        color: #57aa92
      &.left
        width: 494px
        .iview-input
          width: 279px
      &.right
        width: 442px
        padding: 0 10px
        >p
          &.tip
            margin: 10px 0 20px 0
            text-align: center
            color: #f0604c
            font-size: 14px
            min-height: 21px
            line-height: 21px
          margin-left: 102px
          line-height: 30px
        .login-section
          margin-top: 36px
          border-left: #cacaca 1px solid
          padding-left: 40px
        .iview-input
          width: 285px
      .iview-input-code
        width: 190px
      .code-img
        height: 32px
        width: 90px
        vertical-align: top
        margin-left: 3px
      .iview-input-forget
        width: 173px
      .iview-input-forget-button
        margin-left: 8px
        min-width: 88px
      .register-btn
        width: 120px
        line-height: 14px
        font-size: 12px
        cursor: pointer
        &.register
          margin: 50px 0 0 230px
        &.login
          margin: 0 0 0 176px
      >p
        overflow: hidden
        .iview-checkbox
          color: #7a7a7a
        span
          float: right
          padding-right: 18px
</style>
